<template>
  <div class="product-template __donate">

    <h1 data-v-1f20e9ef="" class="page-title text-center">บริจาค</h1>
    <h3 data-v-fe7e2e22="" class="page-title text-center">บริจาคครั้งเดียวเพื่อให้การศึกษาที่มีคุณภาพ</h3>

    <div class="container pd-sm-0">
      <div class="product product--inline">

        <div class="product__block product__image">
          <page-selector
            :product="product"
            v-model="attributes.page"
            v-show="true" />
        </div>

        <div class="product__block--form">
          <div class="block-border radius block shadow">
            <product-donate-choice
              :show-donate-type="false"
              :show-custom-amount-button="false"
              :product="product"
              v-model="product.price"
              ref="donateChoice" />

            <donor-info
              v-model="attributes.info" />

            <product-cart-action
              :product="product"
              :attributes="attributes"
              :initialQuantity="1"
              :addToCartButton="false"
              :buyNowButton="false"
              :style="{margin:0}"
              ref="cartAction" />

            <div class="text-center donate__wrapper">
              <button type="button" class="btn btn--purple" @click.prevent="donate">บริจาค</button>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  export default {
    name: 'ProductDonateTemplate',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {}
      }
    },

    methods: {
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }

  .donate__wrapper {
    margin: 20px 0 0;

    button {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// phapa.vue?085580a0